import InputField from 'components/form-fields/formik/InputField';
import { FormikState } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SessionThresholds } from 'screens/GroupsAndPolicies/types';
import { Header, Segment } from 'semantic';
import { FormGroup } from 'semantic-ui-react';
import PriceField from 'components/form-fields/formik/PriceField';

type Props = {
  basePath?: string;
  currency: string;
  values: FormikState<SessionThresholds>['values'];
};

export const SessionThresholdsFormFields = (props: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Header
        as="h4"
        content={t('sessionThresholds.gracePeriodTitle', 'Grace period')}
      />
      <Segment>
        <FormGroup>
          <InputField
            name="minTimeMinutes"
            label={t('sessionThresholds.minTime', 'Min session time')}
          />
          <InputField
            name="minKwhConsumed"
            label={t('sessionThresholds.minEnergy', 'Min energy consumed')}
          />
        </FormGroup>
      </Segment>
      <Header
        as="h4"
        content={t('sessionThresholds.sessionLimitsTitle', 'Session limits')}
      />
      <Segment>
        <FormGroup>
          <InputField
            name="maxTimeMinutes"
            label={t('sessionThresholds.maxTime', 'Max session time')}
          />
          <InputField
            name="maxKwhConsumed"
            label={t('sessionThresholds.maxEnergy', 'Max energy consumed')}
          />
          <PriceField
            name="maxCost"
            currency={props.currency}
            label={t('sessionThresholds.maxCost', 'Max session cost')}
          />
        </FormGroup>
      </Segment>
    </>
  );
};
